import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    searchString: null,
    searchResult: null,
    secondaryURLs: {
      lobidGND: 'http://lobid.org/gnd/'
    },
    techOutput: {},
    // API Testing
    testData: '',
    // Config
    langs: [
      'en',
      'de'
    ],
    lang: 'de',
    wikipediaArticleLangs: {
      de: 'deutschen',
      en: 'englischen',
      fr: 'französischen',
      pl: 'polnischen',
      sv: 'schwedischen',
      ca: 'katalonischen',
      ro: 'rumänischen',
      cy: 'walisischen',
      ar: 'arabischen',
      et: 'estnischen',
      es: 'spanischen',
      it: 'italienischen',
      da: 'dänischen',
      nl: 'niederländischen',
      ru: 'russischen',
      he: 'hebräischen',
      pt: 'portugiesischen',
      cs: 'tschechischen',
      no: 'norwegischen'



    },
    fetchIterationSize: 3,
    wikiURLs: {
      dewiki: 'https://de.wikipedia.org/wiki/',
      enwiki: 'https://en.wikipedia.org/wiki/',
      commons: 'https://upload.wikimedia.org/wikipedia/commons/8/83/'
    },
    wdProps: [
      {
        number: 'P18',
        variable: 'image',
        value: 'image' 
      },
      {
        number: 'P569',
        variable: 'dateOfBirth',
        value: 'dateOfBirth'
      },
      {
        number: 'P19',
        variable: 'placeOfBirth',
        value: 'placeOfBirthLabel' 
      },
      {
        number: 'P570',
        variable: 'dateOfDeath',
        value: 'dateOfDeath'
      },
      {
        number: 'P20',
        variable: 'placeOfDeath',
        value: 'placeOfDeathLabel'  
      },
      {
        number: 'P227',
        variable: 'gndID',
        value: 'gndID'
      }
    ],
    staticPartsList: {
      plainTexts: [
        'placeholder'
      ],
      htmlTexts: [
        'leaflet'
      ]
    },
    localStaticParts: {
      de: {
        siteTitle: 'Lost Generation Artists?',
        seminarNomination: 'Projektseminar',
        seminarTitle: 'Von den Nationalsozialisten verfolgt - bis heute vergessen',
        seminarSubtitle: 'Digitale Rekonstruktion einer „verlorenen“ Künstlergeneration',
        seminarBy: 'Freie Universität Berlin',
        coopWith: 'in Kooperation mit der Fritz Ascher Society, New York'
        
      }
    },
    staticParts: {},
    pages: [],
    currentPage: '',
    boltArtists: [],
    boltArtistsRaw: [],
    compiledArtists: [],
    outputArtists: [],
    artists: [],
    displayArtists: [],
    currentSortCriterium: {
      first: {
        criterium: 'name',
        direction: 'asc'
      }
    }
  },
  getters: {
    getSearchString (state) {
      return state.searchString
    },
    getSearchResult (state) {
      return state.searchResult
    },
    getSecondaryURLs (state) {
      return state.secondaryURLs
    },
    getTechOutput (state) {
      return state.techOutput
    },
    getDisplayArtists (state) {
      let deepCopy = JSON.parse(JSON.stringify(state.displayArtists))
      let criterium = state.currentSortCriterium.first.criterium
      let direction = state.currentSortCriterium.first.direction
      if (deepCopy) {
        deepCopy.sort((a,b) => {
          if (criterium === 'name') {
            if (a.nameSort > b.nameSort) {
              return direction === 'asc' ? 1 : -1
            }
            if (a.nameSort < b.nameSort) {
              return direction === 'asc' ? -1 : 1
            }
            return 0
          }
          if (criterium === 'dateOfBirth') {
            if (a.dateOfBirth > b.dateOfBirth) {
              return direction === 'asc' ? 1 : -1
            }
            if (a.dateOfBirth < b.dateOfBirth) {
              return direction === 'asc' ? -1 : 1
            }
            return 0
          }
        })
      }
      return deepCopy
    },
    getSparqlArtistsData (state) {
      return state.sparqlArtistsData
    },
    getLocalStaticParts (state) {
      return state.localStaticParts[state.lang]
    },
    getStaticParts (state) {
      return state.staticParts
    },
    getSortSettings (state) {
      return state.currentSortCriterium
    },
    getPageContent (state) {
      let content = {}
      content = state.pages.find(p => p.slug === state.currentPage)
      return content
    }
  },
  mutations: {
    updateTechOutput (state, payload) {
      let newTechOutput = JSON.parse(JSON.stringify(state.techOutput))
      newTechOutput[payload.propKey] = payload.propValue
      state.techOutput = newTechOutput
    }, 
    setArtists (state, payload) {
      state.boltArtistsRaw = payload

      let artists = []
      payload.forEach(a => {
        let artist = {}
        artist.nameDisplay = a.attributes.title
        artist.nameSort = a.attributes.name_sort
        artist.slug = a.attributes.slug
        artist.wikidataID = a.attributes.wikidataid
        artist.wdImage = a.attributes.wikidataimage
        artist.fsek_entries = a.attributes.fsek_db
        artists.push(artist)
      })
      state.artists = artists
    },
    setSortDirection (state, dir) {
      state.currentSortCriterium.first.direction = dir
    },
    setSortCriterium (state, criterium) {
      state.currentSortCriterium.first.criterium = criterium
      if (criterium === 'name') {
        state.currentSortCriterium.first.direction = 'asc'
      }
    },
    setStaticParts (state, payload) {
      let parts = {}
      let attrs = payload.attributes
      state.staticPartsList.plainTexts.forEach(sp => {
        if (attrs.plain_text.find(p => p.handle === sp)) {
          parts[sp] = attrs.plain_text.find(p => p.handle === sp).element 
        } else {
          parts[sp] = 'Element nicht vorhanden'
        }
      })
      state.staticPartsList.htmlTexts.forEach(sp => {
        if (attrs.html_text.find(p => p.handle === sp)) {
          parts[sp] = attrs.html_text.find(p => p.handle === sp).element 
        } else {
          parts[sp] = 'Element nicht vorhanden'
        }
      })
      state.staticParts = parts
    },
    setPages (state, payload) {
      state.pages = payload.map(p => {
        let content = {}
        let attrs = p.attributes
        content.title = attrs.title
        content.content = attrs.body
        content.slug = attrs.slug
        return content
      })
    },
    setCurrentPage (state, payload) {
      state.currentPage = payload
    },
    setSPARQLArtistsData (state, payload) {
      let artistsData = payload.data.results.bindings.map(a => {
        let artist = {}
        artist.wdItem = a['item'].value
        artist.name = a['itemLabel'].value
        if (a['itemDescription']) {
          artist.description = a['itemDescription'].value
        }
        if (a.articles) {
          let wikipediaArticles = a.articles.value
            .split(',')
            .map(a => a
            .trim())
            .filter(a => a.includes('wikipedia.org'))
          artist.wikipediaArticles = wikipediaArticles.map(a => {
            let article = {}
            let langs = Object.entries(state.wikipediaArticleLangs).map(l => l[0])
            langs.forEach(lang => {
              if (a.includes(`${lang}.wikipedia.org`)) {
                article.article = a,
                article.lang = lang
                article.anchorText = state.wikipediaArticleLangs[lang]
              }
            }) 
            return article
          })
        }
        state.wdProps.forEach(prop => {
          if (a[prop.value]) {
            artist[prop.value] = a[prop.value].value
          }
        })
        return artist
      })
      state.sparqlArtistsData = artistsData
      this.commit('setDisplayArtists', artistsData)
    },
    setDisplayArtists (state, payload) {
      let displayArtists = payload.map(a => {
        let currArtist = state.boltArtistsRaw.find(aR => a.wdItem.includes(aR.attributes.wikidataid))
        a.slug = currArtist.attributes.slug
        a.qNumber = currArtist.attributes.wikidataid
        a.nameSort = currArtist.attributes.name_sort
        a.fsek_entries = currArtist.attributes.fsek_db
        a.fsek_entries = !a.fsek_entries ? undefined : a.fsek_entries.map(e => {
          let entry = {}
          entry.titel = e.title
          entry.image = e.image.file? e.image.url + e.image.file : undefined
          entry.thumb = e.image.thumbnail
          entry.permalink= e.permalink
          return entry 
        })
        a.dateOfBirthFilter = a.dateOfBirth.replace('+', '').substring(0,4)
        a.dateOfDeathFilter = a.dateOfDeath.replace('+', '').substring(0,4)
        return a
      })
      // remove duplicates
      let uniqueDisplayArtists = []
      displayArtists.forEach(a => {
        let exists = uniqueDisplayArtists.find(ua => ua.qNumber === a.qNumber)
        if (!exists) uniqueDisplayArtists.push(a)
      })
      displayArtists = uniqueDisplayArtists
      displayArtists.sort((a,b) => {
        if (a.nameSort < b.nameSort) return -1
        else if (a.nameSort > b.nameSort) return 1
        else return 0
      })
      state.displayArtists = displayArtists
    },
    setSearchString(state, payload) {
      state.searchString = payload
    },
    searchItems(state, payload) {
      state.searchResult = null
      let searchTerm = payload.toLowerCase()
      if(searchTerm) {
        let result = state.displayArtists.filter(a => {
          let searchPool = ''
          searchPool += a.name.toLowerCase() + ' '
          searchPool += a.nameSort.toLowerCase() + ' '
          searchPool += a.placeOfBirthLabel.toLowerCase() + ' '
          searchPool += a.placeOfDeathLabel.toLowerCase() + ' ' 
          return searchPool.includes(searchTerm)
        })
        state.searchResult = result
      }
    },
    resetSearch(state) {
      state.searchString = null
      state.searchResult = null
    }
  },
  actions: {
    setSearchString( { commit }, payload) {
      commit('setSearchString', payload)
    },
    resetSearch({ commit }) {
      commit('resetSearch')
    },
    searchItems({ commit }, payload) {
      commit('searchItems', payload)
    },
    fetchArtists ({ commit }) {
      const url ='https://lga-data.culture-to-go.de/json/artists'
      axios.get(url,{
        params:{
          'page[size]': '2000'
        } 
        })
        .then(response => {
            commit('setArtists', response.data.data)
            this.dispatch('fetchSPARQLData')
        })      
    },
    fetchSPARQLData({ commit }){
      let items = ''
      this.state.artists.forEach(a => {
        let item = a.wikidataID
        items += `\nwd:${item}`
      })
      let optionalProps = this.state.wdProps.reduce((prev, curr) => {return prev + `OPTIONAL { ?item wdt:${curr.number} ?${curr.variable}.}\n`},'')
      let queryVarsArr = this.state.wdProps.map(prop => prop.value)
      let queryVarsStr = '?item ?itemLabel ?itemDescription '
      queryVarsStr += queryVarsArr.reduce((prev, curr) => { return prev + `?${curr} `}, '' )
      let query = `
      SELECT ${queryVarsStr} 
      (GROUP_CONCAT(DISTINCT ?article; SEPARATOR=", ") AS ?articles)
      WHERE {
        VALUES ?item {
          ${items}
        }
        ${optionalProps}
        OPTIONAL {
          ?article schema:about ?item .
        }
        SERVICE wikibase:label { bd:serviceParam wikibase:language "de". }
      }
      GROUP BY ${queryVarsStr}
      `
      let queryParams = encodeURI(query)
      let url = 'https://query.wikidata.org/sparql?query=' + queryParams
      let techOutputUpdate = {propKey: 'wdQuery', propValue: 'https://query.wikidata.org/#' + queryParams}
      this.commit('updateTechOutput', techOutputUpdate)
      axios.get(url, {
        params: {
          
        }
      })
      .then(response => {
        commit('setSPARQLArtistsData', response)
      })

    },
    setSortDirection ({ commit }, dir) {
      commit('setSortDirection', dir)
    },
    setSortCriterium ({ commit }, criterium) {
      commit('setSortCriterium', criterium)
    },
    setCurrentPage ({ commit }, payload) {
      commit('setCurrentPage', payload)
    },
    fetchStaticParts ({ commit }) {
      const url ='https://lga-data.culture-to-go.de/json/static_parts'
      axios.get(url,{
        params:{} 
        })
        .then(response => {
            commit('setStaticParts', response.data.data[0])
        })   
    },
    fetchPages ({ commit }) {
      const url ='https://lga-data.culture-to-go.de/json/pages'
      axios.get(url,{
        params:{} 
        })
        .then(response => {
            commit('setPages', response.data.data)
        })   
    },
  }
})
